/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNav_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_user" | "AccountNavTrigger_user" | "TradeAccountNavContent_user">;
    readonly " $refType": "AccountNav_user";
};
export type AccountNav_user$data = AccountNav_user;
export type AccountNav_user$key = {
    readonly " $data"?: AccountNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNav_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "hasTradeUserId",
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AccountNavContent_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Defer",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "AccountNavTrigger_user",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasTradeUserId",
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "TradeAccountNavContent_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '6354207af5acec55e238513ad8e4beab';
export default node;
